<template>
  
  <v-dialog
    v-model   = "isConfirmationDialogOpen"
    width     = "400px"
  >
    <v-card>
      <v-card-title class="text-h5">{{ title }}</v-card-title>
      <v-card-text>{{ message }}</v-card-text>
      <v-card-actions>

        <v-btn
          elevation = "0"
          :color    = "rejectColor"
          @click    = "onReject"
        >
          {{ rejectText }}
        </v-btn>

        <v-btn
          elevation = "0"
          :color    = "acceptColor"
          @click    = "onAccept"
        >
          {{ acceptText }}
        </v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

export default {

  // #region Properties

  name: 'ConfirmationDialog',
  data() {
    return {
      isConfirmationDialogOpen: false,

      title:       '',
      message:     '',
      rejectText:  '',
      rejectColor: '',
      acceptText:  '',
      acceptColor: '',

      resolve: undefined
    }
  },

  // #endregion Properties

  // #region Methods

  methods: {

    // #region Events

    onReject() {
      this.isConfirmationDialogOpen = false;
      this.resolve(false);
    },

    onAccept() {
      this.isConfirmationDialogOpen = false;
      this.resolve(true);
    },

    // #endregion Events

    confirm(
      title,
      message,
      acceptText  = 'OK',
      acceptColor = 'primary',
      rejectText  = 'Cancel',
      rejectColor = 'error'
    ) {
      this.title = title;
      this.message = message;
      this.acceptText = acceptText;
      this.acceptColor = acceptColor;
      this.rejectText = rejectText;
      this.rejectColor = rejectColor;

      this.isConfirmationDialogOpen = true;

      return new Promise(resolve => {
        this.resolve = resolve;
      });
    }

  }

  // #endregion Methods

}

</script>

<style scoped lang="scss">

.v-card__actions {
  display:          flex;
  flex-direction:   row;

  .v-btn {
    flex:             1;
  }
}

</style>